import { memo } from 'react';
import { PrizeWallAwardModalProps } from './PrizeWallAwardModal.types';
import PrizeWallAward from '../../components/PrizeWallAward/PrizeWallAward';

function PrizeWallAwardModal({ close, ...rest }: PrizeWallAwardModalProps) {
  return <PrizeWallAward {...rest} onButtonPress={close} />;
}

export default memo(PrizeWallAwardModal);
